<template>
  <div class="tarja-container" :style="containerPosition">
    <Wrapper class="tarja-svg" />
    <div class="header-text">{{ headerText }}</div>
    <div
      class="description-text"
      :style="{ fontSize: bodyTextSize, lineHeight: lineHeight }"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
import Wrapper from "@/assets/tarjas/GETV/tarja-normal.svg";

export default {
  props: {
    headerText: String,
    text: String,
    posicaoCard: String,
  },
  components: {
    Wrapper,
  },
  data() {
    return {};
  },
  computed: {
    containerPosition() {
      const positions = {
        esquerda: 'left: 125px;',
        centro: 'left: calc(50% - 350px);',
        direita: 'right: 125px;'
      };
      return positions[this.posicaoCard] || positions.esquerda;
    },
    bodyTextSize() {
      const numChars = this.text.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.1rem"
          : numChars > 40 && numChars <= 80
          ? "1.45rem"
          : numChars > 80 && numChars <= 120
          ? "1.4rem"
          : numChars > 120 && numChars <= 160
          ? "1.3rem"
          : numChars > 160 && numChars <= 200
          ? "1.25rem"
          : numChars > 200 && numChars <= 240
          ? "1.15rem"
          : numChars > 240 && numChars <= 280
          ? "1.14rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.text.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.2rem"
          : numChars > 40 && numChars <= 80
          ? "1.6rem"
          : numChars > 80 && numChars <= 120
          ? "1.45rem"
          : numChars > 120 && numChars <= 160
          ? "1.3rem"
          : numChars > 160 && numChars <= 200
          ? "1.25rem"
          : numChars > 200 && numChars <= 240
          ? "1.15rem"
          : numChars > 240 && numChars <= 280
          ? "1.13rem"
          : "1.5rem";

      return lineHeight;
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Globotipo";
  src: url("@/assets/Globotipo_Regular.otf") format("opentype");
}

.tarja-container {
  position: fixed;
  bottom: -65px;
  width: 700px;
  height: 300px;
}

.tarja-svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 700px;
  height: 300px;
}

.header-text {
  position: absolute;
  bottom: 170px;
  left: 30px;
  z-index: 100000;
  font-family: "Globotipo", sans-serif;
  font-size: 1.7rem;
  font-weight: bold;
  font-style: italic;
  color: #fff;
  width: 340px;
  text-transform: uppercase;
}

.description-text {
  position: absolute;
  bottom: 90px;
  left: 35px;
  z-index: 100000;
  font-family: "Globotipo", sans-serif;
  color: rgb(91, 11, 193);
  font-weight: 600;
  width: 625px;
  height: 80px;
  display: flex;
  align-items: center;
}
</style>
